import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const updateEmail = async (email: string, userId: string) => {
  const { data: updateData, error: updateError } = await supabase
    .functions
    .invoke('updateEmail', { body: { email, userId } })

  if (updateError) {
    throw new Error(updateError.message)
  }

  return updateData
}

export default function useUpdateEmailById(email: string, userId: string) {
  return useMutation(() => updateEmail(email, userId), {
    onSuccess: async (data) => data,
  })
}
